import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaixaGerenciarEditarRoutingModule } from './caixa-gerenciar-editar-routing.module';
import { CaixaGerenciarEditarComponent } from './caixa-gerenciar-editar.component';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import {KnobModule} from 'primeng/knob';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MessagesModule } from 'primeng/messages';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { UtilPipeModule } from 'src/app/admihair/util-pipe/util-pipe.module';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  declarations: [
    CaixaGerenciarEditarComponent
  ],
  imports: [
    CommonModule,
    CaixaGerenciarEditarRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule,
    DropdownModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    KnobModule,
    MessagesModule,
    OverlayPanelModule,
    UtilPipeModule,
    DialogModule,
    CalendarModule
    
  ],
  providers: [ConfirmationService]
})
export class CaixaGerenciarEditarModule { }
